import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { COMPANY, whatsappUrl } from "@/data/company";
import { Lines, Reveal } from "@/components/motion/Reveal";
import { Tiles } from "@/components/motion/Tiles";

export const CtaBand = ({ title = ["Ti serve un mezzo", "per domani mattina?"], text = "Chiamaci o scrivici su WhatsApp: ti diciamo subito disponibilità e prezzo, e organizziamo la consegna in cantiere." }) => (
  <section className="relative overflow-hidden bg-blue-600 py-20 text-white sm:py-28" data-testid="cta-band">
    <motion.div
      aria-hidden
      className="pointer-events-none absolute -right-20 -top-20 h-[28rem] w-[28rem] rounded-full bg-white/10 blur-3xl"
      animate={{ scale: [1, 1.15, 1], opacity: [0.6, 1, 0.6] }}
      transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
    />
    <div className="container-x relative grid gap-10 lg:grid-cols-12 lg:items-end">
      <div className="lg:col-span-7">
        <Tiles count={7} size={9} className="mb-5" />
        <Lines as="h2" lines={title} className="display text-4xl sm:text-5xl lg:text-6xl" />
        <Reveal delay={0.3} className="mt-6 max-w-xl text-base text-white/80 sm:text-lg">
          <p>{text}</p>
        </Reveal>
      </div>
      <Reveal delay={0.4} className="flex flex-col gap-3 sm:flex-row lg:col-span-5 lg:justify-end">
        <a href={`tel:${COMPANY.phoneIntl}`} className="btn-dark" data-testid="cta-band-phone">
          <Phone className="h-4 w-4" /> {COMPANY.phoneDisplay}
        </a>
        <a href={whatsappUrl()} target="_blank" rel="noopener noreferrer" className="btn-ghost" data-testid="cta-band-whatsapp">
          WhatsApp <ArrowRight className="h-4 w-4" />
        </a>
        <Link to="/contatti" className="btn-ghost" data-testid="cta-band-quote">
          Preventivo
        </Link>
      </Reveal>
    </div>
  </section>
);
